export default __webpack_public_path__ + "images/ON.f74940b.png";